export default function(whereTo) {
    $('html, body').animate({
        scrollTop: $(whereTo).offset().top - 70
    }, 200);
}
